import * as React from "react";
const SvgBack = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.6667 15L6.66666 10L11.6667 5L12.8333 6.16667L8.99999 10L12.8333 13.8333L11.6667 15Z", fill: "currentColor" }));
export default SvgBack;
